<div class="option">
    <span class="numerals">{char}</span>
    ...{replaceText(card.text, players)}
</div>

<style>
.option{
    border-radius: 50px;
    padding: 0.8em;
    color: #fff;
    font-size: 1em;
    line-height: 1.3em;
    text-align: left;
    margin: 1em auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 200;
    background: linear-gradient(170deg, var(--giga), var(--tera));
    box-shadow:  30px 30px 59px #d3801a, 
             -30px -30px 59px #ffad23;
}
.option > span{
    font-size: 2em;
    padding-left: 0.3em;
    padding-right: 0.3em;
    font-weight: 800;
    color: var(--kilo);
}
</style>

<script>
export let players
export let card
export let char

import { replaceText } from "../../../code/replaceText"
</script>